module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.sk/sk_sk/spolocnost/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.sk/sk_sk/spolocnost/legal-info.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Konfigurátor GROHE SmartControl",
	"homepage.introtext": "Jednoducho odpovedzte na pár otázok nižšie a získajte takú konfiguráciu sprchového systému GROHE SmartControl, aká bude dokonale vyhovovať vašim požiadavkám.",
	"homepage.buttonStart": "Spustiť",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobraziť výsledky",
	"question1.question": "Pre ktorý priestor vašej kúpeľne hľadáte sprchovú konfiguráciu?",
	"question1.option1.text": "Do sprchového kúta",
	"question1.option2.text": "Do vane, t j. vrátane vaňového výpustu",
	"question2.question": "Aký typ inštalácie uprednostňujete? Nástennú, podomietkovú alebo kombináciu oboch?",
	"question2.option1.text": "Nástenná: najjednoduchšie riešenie pre rýchle vylepšenie",
	"question2.option2.text": "Kombinácia: zatiaľ čo potrubie bude ukryté v stene, termostatická batéria s priehradkou budú nástenné",
	"question2.option3.text": "Podomietková: čistý, minimalistický vzhľad, pri ktorom bude všetka technológia ukrytá v stene",
	"question3.question": "Ako by ste chceli svoju sprchu ovládať?",
	"question3.option1.text": "Ovládačom SmartControl s termostatickou batériou",
	"question3.option2.text": "Štandardnou termostatickou batériou",
	"question3.option3.text": "Štandardnou pákovou batériou",
	"question3.option4.text": "Pomocou prepínača (chcem si ponechať súčasnú batériu)",
	"question4.question": "Čo si prajete v rámci sprchy ovládať?",
	"question4.option1.text": "Iba ručnú sprchu",
	"question4.option2.text": "Veľkú hlavovú sprchu (150 – 250 mm) a ručnú sprchu",
	"question4.option3.text": "Extra veľkú hlavovú sprchu (250 – 400 mm) a ručnú sprchu",
	"question4.option4.text": "Veľkú hlavovú sprchu (150 – 250 mm), ručnú sprchu a vaňový výpust",
	"question4.option5.text": "Extra veľkú hlavovú sprchu (250 – 400 mm), ručnú sprchu a vaňový výpust",
	"question5.question": "Aký tvar preferujete?",
	"question5.option1.text": "Štvorcový",
	"question5.option2.text": "Kruhový",
	"question6.question": "Čo si prajete ovládať pomocou vášho nového ovládača SmartControl?",
	"question6.option1.text": "Hlavovú sprchu s dvoma režimami prúdu a ručnú sprchu",
	"question6.option2.text": "Hlavovú sprchu s dvoma režimami prúdu a ručnú sprchu",
	"question6.option3.text": "Iba ručnú sprchu",
	"question6.option4.text": "Hlavovú sprchu a ručnú sprchu",
	"question6.option5.text": "Hlavovú sprchu, dve bočné sprchy a ručnú sprchu",
	"question6.option6.text": "Hlavovú sprchu, ručnú sprchu a vaňový výpust",
	"question6.option7.text": "Ručnú sprchu a vaňový výpust",
	"question6.option8.text": "Iba vaňový výpust",
	"question7.question": "Vyberte si farbu",
	"question7.option1.text": "Chróm",
	"question7.option2.text": "Biela/chróm",
	"question7.option3.text": "Biela/chróm",
	"question8.question": "Prajete si termostatickú batériu s integrovaným držiakom ručnej sprchy?",
	"question8.option1.text": "Áno, chcem mať držiak ručnej sprchy integrovaný do batérie",
	"question8.option2.text": "Nie, držiak ručnej sprchy dokúpim zvlášť",
	"question9.question": "Kam si prajete umiestniť držiak ručnej sprchy?",
	"question9.option1.text": "Na sprchovú tyč prostredníctvom posuvného držiaka",
	"question9.option2.text": "Pomocou minimalistického držiaka ",
	"question10.question": "Prajete si pripevniť vašu hlavovú sprchu na stenu alebo na strop?",
	"question10.option1.text": "Nástenná hlavová sprcha",
	"question10.option2.text": "Stropná hlavová sprcha",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledok} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pre správnu inštaláciu budete potrebovať tiež:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Spustiť novú konfiguráciu",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informácie o produkte",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informácie o produkte",
	"results.product.dealer": "Nájsť showroom",
	"hatchModal.title": "Kúpiť online",
	"hatchModal.btnText": "Kúpiť online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.sk_sk.json
// module id = 766
// module chunks = 0